import Home from '../components/Home/Container'
import Dashboard from '../components/Dashboard/Container'
import Companies from '../components/Companies/Container'
import AddCompany from '../components/AddCompany/Container'
import Company from '../components/Company/Container'
import Products from '../components/Products/Container'
import CreditsLogs from '../components/CreditsLogs/Container'
import Credits from '../components/Credits/Container'
import Groups from '../components/Groups/Container'
import Analysis from '../components/Analysis/Container'

export const routes = [
    {name: 'dashboard', url: '/', sidebar: true, component: Dashboard, roles: ['SUPERADMIN', 'ADMIN', 'STANDARD']},
    {name: 'companies', url: '/companies', sidebar: true, component: Companies, roles: ['SUPERADMIN', 'ADMIN', 'STANDARD']},
    {name: 'prospect', url: '/prospect', sidebar: true, component: Home, roles: ['SUPERADMIN', 'ADMIN', 'STANDARD']},
    {name: 'analysis', url: '/analysis', sidebar: false, component: Analysis, roles: ['SUPERADMIN', 'ADMIN', 'STANDARD']},
    {name: 'products', url: '/products', sidebar: true, component: Products, roles: ['SUPERADMIN', 'ADMIN']},
    {name: 'groups', url: '/groups', sidebar: true, component: Groups, roles: ['SUPERADMIN', 'ADMIN']},
    {name: 'credits', url: '/credits', sidebar: true, component: Credits, roles: ['SUPERADMIN']},
    {name: 'credits_logs', url: '/credits_logs', sidebar: true, component: CreditsLogs, roles: ['SUPERADMIN', 'ADMIN', 'STANDARD']},
    {name: 'company', url: '/companies/:id', component: Company, roles: ['SUPERADMIN', 'ADMIN', 'STANDARD']},
    {name: 'search', url: '/companies/search', component: AddCompany, roles: ['SUPERADMIN', 'ADMIN', 'STANDARD']}
]
